// extracted by mini-css-extract-plugin
module.exports = {"zoomControlls":"styles_zoomControlls__Wuni0","zoomOutIcon":"styles_zoomOutIcon__2FK7l","zoomInIcon":"styles_zoomInIcon__31t8Y","percentage":"styles_percentage__2BzQG"};